import type { EstateItem } from "@/shared/types/estateTypes";

const LINKABLE_ASSET_CATEGORIES = new Set(["Properties", "Vehicles"]);

export function findLinkedSecuredDebts(asset: EstateItem, allItems: EstateItem[]): EstateItem[] {
  if (!LINKABLE_ASSET_CATEGORIES.has(asset.category)) return [];
  return allItems.filter((d) => d.linked_item_id === asset.id && d.category === "Secured debts");
}

export function findLinkedProperty(debt: EstateItem, allItems: EstateItem[]): EstateItem | null {
  if (debt.category !== "Secured debts" || !debt.linked_item_id) return null;
  return allItems.find((a) => a.id === debt.linked_item_id) ?? null;
}
